import { createGlobalStyle } from "styled-components";

export const UnregisterModalStyle = createGlobalStyle`
.unregister-modal {
  .ant-modal-content {
    background: #333336;
    padding: 24px 24px 10px 16px;
  }
  .ant-modal-body {
    padding-top: 0 !important;
  }
  .ant-modal-header,
  .ant-modal-footer {
    background: #333336;
    border: unset;
  }
  .ant-modal-header {
    padding-bottom: 12px;
  }
  .ant-modal-title {
    color: #fff !important;
  }
  .ant-btn {
    border-radius: 4px;
    border-color: transparent;
    &:hover {
      color: #fff;
    }
  }
  .ant-btn-default {
    background-color: #5c5d5f;
  }
}
`;
